function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.5762 40.8306C16.0961 21.9662 31.3623 4 55.6816 4C80.0009 4 96.1738 23.7628 98.8137 40.8306",
  stroke: "white",
  className: "iconWhiteStroke",
  strokeWidth: 7,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 4.45244,
  y1: 29.9729,
  x2: 9.80335,
  y2: 45.4289,
  stroke: "white",
  className: "iconWhiteStroke",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 25.4919,
  y1: 40.7503,
  x2: 10.036,
  y2: 46.1012,
  stroke: "white",
  className: "iconWhiteStroke",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M98.814 56.1694C95.2941 75.0338 80.0278 93 55.7085 93C31.3892 93 15.2164 73.2372 12.5764 56.1694",
  stroke: "white",
  className: "iconWhiteStroke",
  strokeWidth: 7,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 106.938,
  y1: 67.0271,
  x2: 101.587,
  y2: 51.5711,
  stroke: "white",
  className: "iconWhiteStroke",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 85.8982,
  y1: 56.2497,
  x2: 101.354,
  y2: 50.8988,
  stroke: "white",
  className: "iconWhiteStroke",
  strokeWidth: 7,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M75 47.5L43 66L43 29L75 47.5Z",
  fill: "#428EE0",
  className: "iconBlueFill iconBlueStroke",
  stroke: "#428EE0",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 97,
    viewBox: "0 0 112 97",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEyIiBoZWlnaHQ9Ijk3IiB2aWV3Qm94PSIwIDAgMTEyIDk3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPHBhdGggZD0iTTEyLjU3NjIgNDAuODMwNkMxNi4wOTYxIDIxLjk2NjIgMzEuMzYyMyA0IDU1LjY4MTYgNEM4MC4wMDA5IDQgOTYuMTczOCAyMy43NjI4IDk4LjgxMzcgNDAuODMwNiINCiAgICAgIHN0cm9rZT0id2hpdGUiIGNsYXNzPSJpY29uV2hpdGVTdHJva2UiIHN0cm9rZS13aWR0aD0iNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+DQo8bGluZSB4MT0iNC40NTI0NCIgIHkxPSIyOS45NzI5IiB4Mj0iOS44MDMzNSIgeTI9IjQ1LjQyODkiDQogICAgICBzdHJva2U9IndoaXRlIiBjbGFzcz0iaWNvbldoaXRlU3Ryb2tlIiBzdHJva2Utd2lkdGg9IjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPGxpbmUgeDE9IjI1LjQ5MTkiIHkxPSI0MC43NTAzIiB4Mj0iMTAuMDM2IiB5Mj0iNDYuMTAxMiINCiAgICAgIHN0cm9rZT0id2hpdGUiIGNsYXNzPSJpY29uV2hpdGVTdHJva2UiIHN0cm9rZS13aWR0aD0iNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNOTguODE0IDU2LjE2OTRDOTUuMjk0MSA3NS4wMzM4IDgwLjAyNzggOTMgNTUuNzA4NSA5M0MzMS4zODkyIDkzIDE1LjIxNjQgNzMuMjM3MiAxMi41NzY0IDU2LjE2OTQiDQogICAgICBzdHJva2U9IndoaXRlIiBjbGFzcz0iaWNvbldoaXRlU3Ryb2tlIiBzdHJva2Utd2lkdGg9IjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPg0KPGxpbmUgeDE9IjEwNi45MzgiICB5MT0iNjcuMDI3MSIgeDI9IjEwMS41ODciIHkyPSI1MS41NzExIg0KICAgICAgc3Ryb2tlPSJ3aGl0ZSIgY2xhc3M9Imljb25XaGl0ZVN0cm9rZSIgc3Ryb2tlLXdpZHRoPSI3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxsaW5lIHgxPSI4NS44OTgyIiB5MT0iNTYuMjQ5NyIgeDI9IjEwMS4zNTQiIHkyPSI1MC44OTg4Ig0KICAgICAgc3Ryb2tlPSJ3aGl0ZSIgY2xhc3M9Imljb25XaGl0ZVN0cm9rZSIgc3Ryb2tlLXdpZHRoPSI3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik03NSA0Ny41TDQzIDY2TDQzIDI5TDc1IDQ3LjVaIg0KICAgICAgZmlsbD0iIzQyOEVFMCIgY2xhc3M9Imljb25CbHVlRmlsbCBpY29uQmx1ZVN0cm9rZSIgc3Ryb2tlPSIjNDI4RUUwIiAgIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg==";
export { SvgComponent as ReactComponent };